import { createAction } from 'redux-actions';

const moduleName = 'lightbox';

export const LIGHTBOX_SHOW = `${moduleName}/LIGHTBOX_SHOW`;
export const LIGHTBOX_CLOSE = `${moduleName}/LIGHTBOX_CLOSE`;

export const showLightbox = createAction(LIGHTBOX_SHOW);
export const closeLightbox = createAction(LIGHTBOX_CLOSE);

